module.exports = require("v-runtime-template");